export function formatDate(inputDate) {
  // Buat objek Date dari input string
  const date = new Date(inputDate);

  // Daftar nama hari dalam bahasa Indonesia
  const days = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];

  // Daftar nama bulan dalam bahasa Indonesia
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  // Ambil komponen tanggal
  const dayName = days[date.getUTCDay()]; // Nama hari
  const day = date.getUTCDate(); // Tanggal (1-31)
  const month = months[date.getUTCMonth()]; // Nama bulan
  const year = date.getUTCFullYear(); // Tahun
  const hours = String(date.getUTCHours()).padStart(2, "0"); // Jam (24 jam)
  const minutes = String(date.getUTCMinutes()).padStart(2, "0"); // Menit

  // Gabungkan semua komponen menjadi format yang diinginkan
  return `${dayName}, ${day}-${month}-${year} ${hours}:${minutes}`;
}

export function formatTimeDate(inputDate) {
  // Buat objek Date dari input string
  const date = new Date(inputDate);

  // Ambil komponen tanggal
  const year = date.getUTCFullYear(); // Tahun (YYYY)
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Bulan (MM), ditambah 1 karena bulan dimulai dari 0
  const day = String(date.getUTCDate()).padStart(2, "0"); // Hari (DD)
  const hours = String(date.getUTCHours()).padStart(2, "0"); // Jam (HH)
  const minutes = String(date.getUTCMinutes()).padStart(2, "0"); // Menit (mm)

  // Gabungkan semua komponen menjadi format YYYY-MM-DD HH:mm
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

export const isDatePassed = (dateToCompare) => {
  // Mengonversi tanggal input ke objek Date
  const targetDate = new Date(dateToCompare);

  // Mendapatkan tanggal dan waktu saat ini
  const today = new Date();

  console.log("Current Date and Time:", today);
  console.log("Target Date and Time:", targetDate);

  // Membandingkan tanggal dan waktu secara langsung
  return targetDate <= today; // True jika tanggal sudah lewat, false jika belum
};
